import React from 'react';
import classNames from 'classnames';

export default function CircularLessIcon({ className = '' }) {
	return <span className={classNames('icon icon-item_remove', className)} />;
}
